import { ReactNode, useEffect, useState } from 'react';
import { Layout, ConfigProvider, theme } from 'antd';
import locale from 'antd/es/locale/pt_BR';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

import Header from './Header';
import Main from './Main';
import Sidebar from './Sidebar';

type LayoutProps = {
  children: ReactNode;
};
const LayoutAdmin = ({ children }: LayoutProps) => {
  const { darkAlgorithm, defaultAlgorithm } = theme;
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const screens = useBreakpoint();

  useEffect(() => {
    const prefersColorScheme = window.matchMedia(
      '(prefers-color-scheme: dark)'
    );

    prefersColorScheme.addEventListener('change', function (event) {
      if (event.matches) {
        setIsDarkMode(true);
      } else {
        setIsDarkMode(false);
      }
    });

    if (prefersColorScheme.matches) {
      setIsDarkMode(true);
    } else {
      setIsDarkMode(false);
    }
  }, []);

  return (
    <ConfigProvider
      locale={locale}
      theme={{ algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm }}
    >
      <Layout style={{ height: '100%' }}>
        {screens.md && <Sidebar open={sidebarOpen} />}
        <Layout>
          <Header onSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} />
          <Main>{children}</Main>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default LayoutAdmin;
